import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EventBrellaLayout from './EventBrellaLayout';
import EventBrellaClientMarquee from './EventBrellaClientMarquee';
import HeroSlideshow from './HeroSlideshow';
import { useTalkToUs } from './TalkToUsPopup';
import { submitEventbrellaProspect } from './submitEventbrellaProspect';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EventBrellaHomeInner = () => {
  const { openTalkToUs } = useTalkToUs();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedPhone = phone.trim();

    if (!trimmedName) {
      setError('Please enter your name.');
      return;
    }
    if (!trimmedEmail || !EMAIL_RE.test(trimmedEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    setSubmitting(true);
    const result = await submitEventbrellaProspect({
      name: trimmedName,
      email: trimmedEmail,
      phone: trimmedPhone || undefined,
    });
    setSubmitting(false);

    if (!result.ok) {
      setError(
        result.error === 'not_configured'
          ? 'Something went wrong. Please try again later.'
          : 'Something went wrong. Please try again.'
      );
      return;
    }

    setSubmitted(true);
  };

  return (
    <>
      <EventBrellaClientMarquee />
      <header className="hero">
        <div className="spotlight left" />
        <div className="spotlight right" />
        <div className="wrap hero-split">
          <div className="hero-media">
            <HeroSlideshow />
          </div>
          <div className="hero-copy">
            <h1>
              <span className="foil">EventBrella turns</span>
              <span className="foil line2">every event into</span>
              <span className="line2">compounding revenue</span>
            </h1>
            <p className="sub">
              Tickets, tables, parking &amp; mobile ordering, all under your brand.
            </p>

            {submitted ? (
              <p className="hero-form-success" role="status">
                Thanks — we&apos;ll be in touch.
              </p>
            ) : (
              <form className="hero-lead-form" onSubmit={handleSubmit} noValidate>
                <label className="hero-lead-field">
                  <span>Name <em>*</em></span>
                  <span className="hero-lead-spark">
                    <input
                      type="text"
                      name="name"
                      autoComplete="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </span>
                </label>
                <label className="hero-lead-field">
                  <span>Email <em>*</em></span>
                  <span className="hero-lead-spark">
                    <input
                      type="email"
                      name="email"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </span>
                </label>
                <label className="hero-lead-field">
                  <span>Phone</span>
                  <span className="hero-lead-spark">
                    <input
                      type="tel"
                      name="phone"
                      autoComplete="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </span>
                </label>
                {error ? (
                  <p className="hero-lead-error" role="alert">{error}</p>
                ) : null}
                <div className="hero-ctas">
                  <button type="submit" className="btn btn-gold" disabled={submitting}>
                    {submitting ? 'Submitting…' : 'Submit'}
                  </button>
                  <Link to="/roi" className="btn btn-ghost">
                    See the ROI Breakdown
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </header>

      <section className="zero-section">
        <div className="wrap zero-grid">
          <div>
            <div className="zero-number">0%</div>
            <span className="zero-cap">Of last month's crowd you actually own</span>
          </div>
          <div className="zero-copy">
            <span className="eyebrow" style={{ color: 'var(--gold-1)' }}>The Problem</span>
            <h2 style={{ marginTop: 18 }}>Every event starts from zero.</h2>
            <p>
              Last month's attendees disappear. Instagram forgets. The algorithm resets. Outdated ticketing platforms keep the emails, the phone numbers, the purchase history — and sell that relationship back to you as an ad, one event at a time.
            </p>
            <p className="kicker">Every ticket should make the next event easier to sell. Right now, it doesn't.</p>
          </div>
        </div>
      </section>

      <section className="final-cta" id="cta">
        <div className="wrap">
          <span className="eyebrow">Stop Renting</span>
          <h2 className="foil" style={{ marginTop: 18 }}>Start owning.</h2>
          <p className="sub">
            Bring your next event to EventBrella and keep what it earns — the revenue, and the relationship.
          </p>
          <button type="button" className="btn btn-gold" onClick={openTalkToUs}>
            Talk to Us
          </button>
        </div>
      </section>
    </>
  );
};

const EventBrellaHome = () => (
  <EventBrellaLayout>
    <EventBrellaHomeInner />
  </EventBrellaLayout>
);

export default EventBrellaHome;
